const Simple = ({ title, subtitle, children, actions, head }) => {
  return (
    <div className={`simple__card`}>
      <div className="simple__card--head">
        {head && <div className="simple__card--head--node">{head}</div>}
        {title && (
          <div className="simple__card--head--title">
            <h3>{title}</h3>
            <span>{subtitle}</span>
          </div>
        )}
        <div className="simple__card--head--actions">{actions}</div>
      </div>
      {children && <div className="simple__card--body">{children}</div>}
    </div>
  );
};

export default Simple;
